import { Icon, SelectionSheet, BackgroundIcon } from '@nile/components';
import { Sheet, Button } from '@superops/ui-design-system';
import { Columns } from '@styled-icons/fa-solid/Columns';
import React, { useCallback, useState } from 'react';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

function ListViewColumns(props) {
  const [sheetActive, setSheetActive] = useState(false);
  const toggleSheetActive = useCallback(
    () => setSheetActive((sheetActive) => !sheetActive),
    []
  );
  const {
    columns,
    sections,
    actions,
    meta,
    data,
    header,
    selectedItems,
    updateParent,
    activator,
    text,
    noCheckbox,
    noSearchBar,
    buttonLoading
  } = props;
  return (
    <div>
      {activator ? (
        <div onClick={toggleSheetActive}>{activator}</div>
      ) : (
        <Button
          onClick={toggleSheetActive}
          icon={<SVGIcon name="Columns" />}
          loading={buttonLoading}
        >
          {text || 'Configure columns'}
        </Button>
      )}
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        <SelectionSheet
          columns={columns}
          sections={sections}
          actions={actions}
          meta={meta}
          data={data}
          header={header}
          selectedItems={selectedItems}
          updateParent={updateParent}
          canReorder
          toggleSheetActive={toggleSheetActive}
          noCheckbox={noCheckbox || false}
          noSearchBar={noSearchBar || false}
        />
      </Sheet>
    </div>
  );
}

export default ListViewColumns;
